export default {
  userInfo: state => state.userInfo,
  // liveInfo: state => state.liveInfo,
  userList: state => state.userList,
  allUserList: state => state.allUserList,
  liveResult: state => state.liveResult,
  roomStatus: state => state.roomStatus,
  permissionData: state => state.permissionData,
};
